import React, {useEffect, useState} from 'react';
import { useParams } from 'react-router-dom';
import {getHomeOffersData} from '../../utils/endpoints'
import InnerContent from '../components/innerContent';
import { Container } from 'react-bootstrap';
import Breadcrumb from '../components/breadcrumb';
import Loading from '../components/loading';
import GalleryCard from '../components/galleryCard';
import { Helmet } from 'react-helmet';

const OfferDetails = (props) => {
    const [offersData, setOffersData] = useState(null);
    const {id} = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    
    useEffect(() => {
        const fetchData = async () => {
          try {
            const offersData = await getHomeOffersData(id);
            setOffersData(offersData);
            setIsLoading(false);
          } catch (error) {
            setError(error);
            setIsLoading(false);
          }
        };
      
        fetchData();
      }, [id]);
      

      if (isLoading) {
        return <div><Loading /></div>;
      }
    
      if (error) {
    return (
    <div className='error_modal'>
      <div className='error_modal-wrapper'>
        <img  src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="Statue of Belief"/>
        <h1>We’re making a few improvements to serve you better. Please check back shortly for an enhanced experience.</h1>
        <button class="reload-btn" onClick={() => window.location.reload()}>
            Reload Page
        </button>
      </div>
    </div>
    );
  }

  return (
    <div>
      <Helmet>
      <title>{offersData[0]?.title?.rendered} || Statue of Belief || Worlds tallest shiva Statue</title>
      </Helmet>
      <Container>
        <Breadcrumb pageTitle={offersData[0]?.title?.rendered}/>
        <h1 className="blog-heading">{offersData[0]?.title?.rendered}</h1>
        <InnerContent compData={offersData}/>
        <GalleryCard />
      </Container>
    </div>
  );
};

export default OfferDetails;